import { Modal } from '@app/components/various/Modal';
import { useCreateNewSelectionFromWishlist } from '@app/services/hooks/lookbook/useCreateNewSelectionFromWishlist';
import { BuyerForNewSelection, Lookbook } from '@typings';
import { useTranslation } from 'react-i18next';

import { isDefined } from '../../utils/is';
import { isEmpty } from '../../utils/isEmpty';

import { CreateSelectionForm } from './CreateSelectionForm';

interface Props {
  products: string[];
  deliveryWindows: string[];
  isOpen: boolean;
  onClose: VoidFunction;
}

export const CreateSelectionFromWishlistModal = ({ products, deliveryWindows, isOpen, onClose }: Props) => {
  const { t } = useTranslation(['common', 'selections']);
  const { mutate, isPending } = useCreateNewSelectionFromWishlist({ onSuccess: onClose });

  const handleSubmit = ({ selectionName, buyers }: { selectionName?: string; buyers?: BuyerForNewSelection[] }) => {
    const payload: Lookbook.CreateSelectionFromWishlistFormData = {
      deliveryWindows,
      products,
      ...(isDefined(buyers) && !isEmpty(buyers) && { buyers }),
      ...(isDefined(selectionName) && { selectionName }),
    };

    mutate({ data: payload });
  };

  return (
    <Modal
      title={t('selections:copy_to_new_selection')}
      description={t('selections:copy_to_new_selection_description')}
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <CreateSelectionForm submitTitle={t('common:create')} onClose={onClose} onSubmit={handleSubmit} isPending={isPending} />
    </Modal>
  );
};
